import * as React from 'react';
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { isMobile } from "react-device-detect";

const Toast = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100vh;
display: flex;
justify-content: center;
align-items: center;
`;

const CloseModalButton = styled(MdClose)`
background-color: ;
color: white;
cursor: pointer;
position: absolute;
top: 10px;
right: 10px;
width: 32px;
height: 32px;
`;
const ToastInner = styled.div`
position: relative;
${'' /* padding: 32px; */}
width: 100%;
background-color: rgb(238, 81, 8);
color: white;
margin-top: auto;
overflow:visible;
`;
const Center = styled.div`
text-align: center;
display: flex;
justify-content: space-evenly;
flex-wrap: wrap;
`;

const CusToast =(props) => {
  return props.trigger ? (
    <>
    {isMobile?  
      <React.Fragment>
        <NotificationGroup>
          <Fade>
            <Notification type={{ icon: true}} 
              closable={true} onClose={()=>{
                props.setTrigger(false); 
                clearTimeout(props.timer);
              }}>
              <span>{props.label}</span>
            </Notification>
          </Fade>
        </NotificationGroup>
      </React.Fragment>
      :
      <Toast>
        <ToastInner className="toastTxtPadding">
          <CloseModalButton 
            aria-label="Close modal"
            onClick={() => {
            props.setTrigger(false); 
            clearTimeout(props.timer);
            }
          } />
          <Center>
            <div className="fbaPSize">
              <div className="dcPgm">{props.label}</div>
            </div>
          </Center>
        </ToastInner>
      </Toast>
    }
    </>
  ) : (
    ""
  );
}

export default CusToast;
